import { render, staticRenderFns } from "./CategoryEditProduct.vue?vue&type=template&id=0c1aca0f&"
import script from "./CategoryEditProduct.vue?vue&type=script&lang=js&"
export * from "./CategoryEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports